
import { Button, Loading, Alert } from 'element-ui';
import BlockSlider from '@/components/BlockSlider.vue';
import CategoryFilters from '@/components/pages/category/CategoryFilters.vue';
import BlockText from '@/components/BlockText.vue';
import Banner from '@/components/Banner.vue';
import FooterApp from '@/components/FooterApp.vue';
import ProductCardDefaultMultiple from '@/components/ProductCard/ProductCardDefaultMultiple.vue';

import Teleport from 'vue2-teleport';
// let page = 1;

function listToString(list) {
  if (list.length > 0) {
    let text = '';
    list.map((item, index) => {
      if (index !== 0) {
        text += ',';
      }
      text += item;
    });
    return text;
  } else {
    return null;
  }
}

function getIdCategory(permalink) {
  const regex = /(\d+)/;
  const match = permalink.match(regex);
  if (match) {
    return match[0];
  } else {
    return null;
  }
}

async function fetchCategory(store, { permalink, token }) {
  // const idCategory = getIdCategory(permalink);
  if (permalink) {
    await store.dispatch('newCategory/fetchCategory', {
      permalink,
      token,
    });
  }
}

async function fetchProducts(
  store,
  {
    permalink,
    idsAttribute = [],
    prices = [],
    promotion = false,
    page = 1,
    orderBy = null,
    token,
  }
) {
  // const idCategory = getIdCategory(permalink);
  if (permalink) {
    await store.dispatch('newCategory/fetchProducts', {
      idsAttribute,
      prices,
      page,
      orderBy,
      permalink,
      promotion,
      token,
    });
  }
}

async function fetchMoreProducts(
  store,
  { permalink, idsAttribute = [], prices = [], page, orderBy = null }
) {
  // const idCategory = getIdCategory(permalink);
  if (permalink) {
    await store.dispatch('newCategory/fetchMoreProducts', {
      permalink,
      idsAttribute,
      prices,
      page,
      orderBy,
    });
  }
}

function sortBy(val) {
  switch (val) {
    case 'price_asc':
      return {
        sortby: 'SortByPrice',
        value: 'ASC',
      };
    case 'price_desc':
      return {
        sortby: 'SortByPrice',
        value: 'DESC',
      };
    case 'newest_asc':
      return {
        sortby: 'SortByNewest',
        value: 'DESC',
      };
    case 'newest_desc':
      return {
        sortby: 'SortByNewest',
        value: 'ASC',
      };
    default:
      return {
        sortby: 'Default',
        value: 'DESC',
      };
  }
}

export default {
  layout: 'MainLayout',
  name: 'categoryPage',
  auth: false,

  head() {
    if (!this.seo) {
      return {
        title: this.categoryTitle || this.$t('Category'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.categoryDiscriptonShort || this.categoryTitle || '',
          },
        ],
      };
    }

    const meta = [
      {
        hid: 'description',
        name: 'description',
        content: this.seo.MetaDescription || this.categoryDiscriptonShort || '',
      },
    ];

    // Add og:image if available
    const ogImage = this.images?.category_medium?.Src;
    if (ogImage) {
      meta.push({
        hid: 'og:image',
        property: 'og:image',
        content: ogImage,
      });
    }

    return {
      title: this.seo.MetaTitle || this.categoryTitle || this.$t('Category'),
      meta,
    };
  },

  data() {
    const permalink = this.$route.params.cat;
    const query = this.$route.query || {};

    // Parse query parameters safely
    let page = parseInt(query.page) || 1;
    let idsAttribute = [];
    let prices = [];
    let sort = null;
    let promotion = false;

    if (query.attributes) {
      idsAttribute = query.attributes.split(',').filter(Boolean);
    }
    if (query.prices) {
      prices = query.prices.split(',').filter(Boolean);
    }
    if (query.promotion === '1') {
      promotion = true;
    }
    if (query.sort) {
      sort = sortBy(query.sort);
      this.$store.commit('newCategory/setOrderBy', {
        value: query.sort,
      });
    }

    // Set initial filters in store
    this.$store.commit('newCategory/setFilters', {
      idsAttribute,
      prices,
      promotion,
    });

    const rowDisplay =
      this.$auth.$storage.getLocalStorage('ROW_DISPLAY') || 'full';

    this.$store.commit('shop/categories/setDisplayRow', rowDisplay);

    return {
      isFirstLoading: false,
      permalink,
      page,
      minPage: page,
      idsAttribute,
      prices,
      promotion,
      orderBy: sort,
      limit: 31,
      isLodingMore: true,
      showLoadMore: true,
      token: query.token || null,
      queryProductId: query.product || null,
    };
  },

  computed: {
    notFound() {
      return this.$store.state.newCategory?.notFound || false;
    },
    notFoundMsg() {
      return this.$store.state.newCategory?.error || '';
    },
    loading() {
      return this.$store.state.newCategory?.loading || false;
    },

    hasNextPage() {
      return this.$store.state.newCategory?.hasNextPage || false;
    },
    getData() {
      return this.$store.state.newCategory?.currentCategory || null;
    },
    products() {
      return this.$store.state.newCategory?.products || [];
    },
    safeProducts() {
      return Array.isArray(this.products)
        ? this.products.filter((product) => product && product.IdProduct)
        : [];
    },
    nbrProduct() {
      return this.$store.state.newCategory?.totalProduct || 0;
    },
    categoryDiscription() {
      return this.getData?.Description || null;
    },
    categoryTitle() {
      return this.categoryDiscription?.Title || '';
    },
    categoryDiscripton() {
      return this.categoryDiscription?.Description || '';
    },
    categoryDiscriptonShort() {
      return this.categoryDiscription?.DescriptionShort || '';
    },
    breadcrumbLinks() {
      return [
        {
          link: '/',
          text: this.$t('Home'),
        },
        {
          text: this.categoryTitle || this.$t('Category'),
        },
      ];
    },
    seo() {
      if (!this.getData?.SEO || !Array.isArray(this.getData.SEO)) {
        return null;
      }

      let seoIndex = 0; // Default to French
      if (this.$i18n.locale === 'en') {
        seoIndex = 1;
      } else if (this.$i18n.locale === 'de') {
        seoIndex = 2;
      }

      return this.getData.SEO[seoIndex] || this.getData.SEO[0] || null;
    },
    images() {
      return this.getData?.Media?.Image || null;
    },
    videoUrl() {
      const video = this.getData?.Media?.Video;
      if (video?.Cover && video?.CategoryVideoVimeoUrl) {
        return video.CategoryVideoVimeoUrl;
      }
      return null;
    },

    filterPriceRange() {
      return this.getData?.Filters?.PriceRange || {};
    },
    filterSizes() {
      return this.getData?.Filters?.Sizes || [];
    },
    filterColors() {
      return this.getData?.Filters?.Colors || [];
    },

    showMobileSizes: {
      get() {
        return this.$store.state.popups?.addToCartMobile?.show || false;
      },
      set(value) {
        this.$store.commit('popups/addToCartMobile/removeProduct', value);
      },
    },
    productForAddMobile() {
      return this.$store.state.popups?.addToCartMobile?.product || null;
    },
    colorForAddMobile() {
      return this.$store.state.popups?.addToCartMobile?.color || null;
    },
    safeMobileSizes() {
      const product = this.productForAddMobile;
      return Array.isArray(product?.Sizes) ? product.Sizes : [];
    },
    rowDisplay() {
      return this.$store.state.shop.categories?.rowDisplay;
    },
  },

  methods: {
    async firstLoading() {
      try {
        this.isLodingMore = true;
        this.isFirstLoading = true;

        if (!this.permalink) {
          console.error('No permalink provided');
          return;
        }

        await fetchCategory(this.$store, {
          permalink: this.permalink,
          token: this.token,
        });

        // Fix pagination issue (this.page === 1 || this.products.length === 0)
        if (this.page === 1 || this.products.length === 0) {
          await fetchProducts(this.$store, {
            permalink: this.permalink,
            idsAttribute: this.idsAttribute,
            prices: this.prices,
            promotion: this.promotion,
            page: this.page,
            orderBy: this.orderBy,
            token: this.token,
          });

          if (this.queryProductId) {
            if (process.client) {
              setTimeout(() => {
                const targetElement = document.querySelector(
                  `#p${this.queryProductId}`
                );

                if (targetElement) {
                  targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  });
                }
              }, 300);
            }
          }
        }
      } catch (error) {
        console.error('Error in firstLoading:', error);
        // Handle error gracefully - maybe show a toast or set an error state
      } finally {
        this.isFirstLoading = false;
        this.isLodingMore = false;
      }
    },

    async permalinkLangUrl() {
      try {
        const links = {};
        const seoData = this.getData?.SEO;

        if (Array.isArray(seoData)) {
          seoData.forEach((item) => {
            if (item?.LanguageIsoCode && item?.URL) {
              links[item.LanguageIsoCode.toLowerCase()] = {
                cat: item.URL,
              };
            }
          });

          if (Object.keys(links).length > 0) {
            await this.$store.dispatch('i18n/setRouteParams', links);
          }
        }
      } catch (error) {
        console.error('Error in permalinkLangUrl:', error);
      }
    },
    getCardType(product, index) {
      if (!product) return 'image';

      if (index === 0) {
        return this.$SETTINGS.isMobile ? 'slider' : 'multiImage';
      }
      // else if (index === 4) {
      //   return 'image';
      // }
      else {
        return 'slider';
      }
    },
    getCardClassWrpper(index) {
      const mbDisplay =
        this.rowDisplay === 'full' ? 'col-span-4' : 'col-span-2';

      if (index === 0) {
        return mbDisplay + ' lg:col-span-3';
      } else if (index === 4) {
        return 'col-span-4 md:col-span-2 row-span-1 lg:row-span-2';
      } else {
        return mbDisplay + ' md:col-span-2 lg:col-span-1 row-span-1';
      }
    },

    async loadMore() {
      if (this.isLodingMore || !this.hasNextPage) {
        return;
      }

      try {
        this.page++;
        this.isLodingMore = true;

        await fetchMoreProducts(this.$store, {
          permalink: this.permalink,
          page: this.page,
          idsAttribute: this.idsAttribute,
          prices: this.prices,
          orderBy: this.orderBy,
        });

        const updatedQuery = { ...this.$route.query };
        updatedQuery.page = this.page;

        await this.$router
          .replace({
            query: updatedQuery,
          })
          .catch(() => {});
      } catch (error) {
        console.error('Error loading more products:', error);
        this.page--; // Revert page increment on error
      } finally {
        this.isLodingMore = false;
      }
    },

    async loadLess() {
      if (this.isLodingMore || this.minPage <= 1) {
        return;
      }

      try {
        this.minPage--;
        this.isLodingMore = true;

        // Store scroll position to avoid jump
        const currentScroll = window.scrollY;
        const firstProduct = this.safeProducts[0];
        const firstProductEl = firstProduct
          ? document.getElementById(`p${firstProduct.IdProduct}`)
          : null;
        const firstProductOffset = firstProductEl
          ? firstProductEl.offsetTop
          : 0;

        await this.$store.dispatch('newCategory/fetchPreviousProducts', {
          permalink: this.permalink,
          page: this.minPage,
          idsAttribute: this.idsAttribute,
          prices: this.prices,
          promotion: this.promotion,
          orderBy: this.orderBy,
        });

        const updatedQuery = { ...this.$route.query };
        updatedQuery.page = this.minPage;

        await this.$router
          .replace({
            query: updatedQuery,
          })
          .catch(() => {});

        // Adjust scroll after DOM update
        if (process.client) {
          this.$nextTick(() => {
            const newFirstProductEl = firstProduct
              ? document.getElementById(`p${firstProduct.IdProduct}`)
              : null;
            if (newFirstProductEl) {
              const newFirstProductOffset = newFirstProductEl.offsetTop;
              const diff = newFirstProductOffset - firstProductOffset;
              window.scrollTo(0, currentScroll + diff);
            }
          });
        }
      } catch (error) {
        console.error('Error loading previous products:', error);
        this.minPage++;
      } finally {
        this.isLodingMore = false;
      }
    },

    handleScroll() {
      try {
        if (!this.isLodingMore && this.hasNextPage) {
          const loadMoreBtn = this.$refs['loadMoreBtn'];
          if (loadMoreBtn && loadMoreBtn.offsetTop) {
            if (
              loadMoreBtn.offsetTop <=
              window.scrollY + window.innerHeight + 992
            ) {
              this.loadMore();
            }
          }
        }
        if (this.showMobileSizes) {
          this.showMobileSizes = false;
        }
      } catch (error) {
        console.error('Error in handleScroll:', error);
      }
    },
    addToCart(size) {
      try {
        if (!this.productForAddMobile || !size) {
          console.error('Missing product or size for cart');
          return;
        }

        const cartHelper = new CartHelper(this.$http, this.$store, this.$auth);
        const item = {
          product: this.productForAddMobile,
          color: this.colorForAddMobile,
          size: size,
          quantity: 1,
        };

        if (this.$auth.loggedIn) {
          cartHelper.addProductToCart(item);
        } else {
          cartHelper.addProductToCartGuest(item);
        }

        // Close the mobile sizes modal
        this.showMobileSizes = false;
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    },
    async filterHandler(event) {
      if (!event || this.isLodingMore) {
        return;
      }

      try {
        const orderBy = event.sort ? sortBy(event.sort) : null;

        this.idsAttribute = event.idsAttribute || [];
        this.prices = event.prices || [];
        this.promotion = event.promotion || false;
        this.orderBy = orderBy;
        this.page = 1;

        await fetchProducts(this.$store, {
          permalink: this.permalink,
          idsAttribute: this.idsAttribute,
          prices: this.prices,
          promotion: this.promotion,
          orderBy: orderBy,
          page: this.page,
        });

        // Build query parameters properly
        const updatedQuery = { ...this.$route.query };

        // Handle attributes
        if (event.idsAttribute && event.idsAttribute.length > 0) {
          updatedQuery.attributes = listToString(event.idsAttribute);
        } else {
          delete updatedQuery.attributes;
        }

        // Handle prices
        if (event.prices && event.prices.length > 0) {
          updatedQuery.prices = listToString(event.prices);
        } else {
          delete updatedQuery.prices;
        }

        // Handle promotion
        if (event.promotion === true) {
          updatedQuery.promotion = 1;
        } else {
          delete updatedQuery.promotion;
        }

        // Handle sort
        if (event.sort) {
          updatedQuery.sort = event.sort;
        } else {
          delete updatedQuery.sort;
        }

        // Remove page from query when filtering
        delete updatedQuery.page;

        await this.$router
          .replace({
            query: updatedQuery,
          })
          .catch(() => {});
      } catch (error) {
        console.error('Error in filterHandler:', error);
      }
    },
    getCategoryLink() {
      return this.seo?.URL || 'product';
    },
    displayHandler(type) {
      this.$auth.$storage.setLocalStorage('ROW_DISPLAY', type);
      this.$store.commit('shop/categories/setDisplayRow', type);
    },
  },

  created() {
    this.firstLoading();
  },
  activated() {
    if (process.client) {
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
  },
  deactivated() {
    if (process.client) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },

  async mounted() {
    try {
      this.isLodingMore = false;

      if (process.client) {
        window.scrollTo(0, 0);
      }

      const LAST_CATEGORY_VISITED = 'LAST_CATEGORY_VISITED';

      if (this.$cookies && this.$route?.path) {
        this.$cookies.set(LAST_CATEGORY_VISITED, this.$route.path, {
          path: '/',
          maxAge: 60 * 60 * 24 * 7,
        });
      }

      await this.permalinkLangUrl();
    } catch (error) {
      console.error('Error in mounted:', error);
    }
  },
  watch: {
    '$route.query': {
      handler(newQuery, oldQuery) {
        // Handle route query changes for better navigation
        if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
          // Only reload if significant parameters changed
          const significantParams = [
            'attributes',
            'prices',
            'promotion',
            'sort',
          ];
          const hasSignificantChange = significantParams.some(
            (param) => newQuery[param] !== oldQuery[param]
          );

          if (hasSignificantChange) {
            this.firstLoading();
          }
        }
      },
      deep: true,
    },
  },
  components: {
    BlockSlider,
    BlockText,
    Banner,
    FooterApp,
    Button,
    Teleport,
    CategoryFilters,
    ProductCardDefaultMultiple,
    Alert,
  },
};
